import { Anchor, FlexRow, Text, theme } from '@veeqo/ui';
import { ContentType, copy } from '../content';

export const Footer = ({ contentType }: { contentType: ContentType }) => (
  <FlexRow
    justifyContent="space-between"
    style={{
      padding: theme.sizes[12],
      width: `calc(100% - ${parseInt(theme.sizes[12], 10) * 2}rem)`,
    }}
  >
    <FlexRow justifyContent="flex-start" gap="md">
      <Anchor
        variant="unstyled"
        href={copy[contentType].termsUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
          {copy[contentType].termsText}
        </Text>
      </Anchor>
      <Anchor
        variant="unstyled"
        href={copy[contentType].privacyUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
          {copy[contentType].privacyText}
        </Text>
      </Anchor>
      <Anchor
        variant="unstyled"
        href={copy[contentType].securityUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
          {copy[contentType].securityText}
        </Text>
      </Anchor>
    </FlexRow>
    <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
      {copy[contentType].copyrightText(new Date().getFullYear())}
    </Text>
  </FlexRow>
);
